import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const RadioOff = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 4.09c4.36 0 7.91 3.55 7.91 7.91s-3.55 7.91-7.91 7.91S4.09 16.36 4.09 12 7.64 4.09 12 4.09Zm0-1.8c-5.36 0-9.71 4.35-9.71 9.71 0 5.36 4.35 9.71 9.71 9.71 5.36 0 9.71-4.35 9.71-9.71 0-5.36-4.35-9.71-9.71-9.71Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default RadioOff
